import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Spin } from 'antd';

import { StepFiveWrapper } from '../style'
import Badge from '../../../../../../components/uiComponent/bages';

const StepFive = () => {
  const {
    shipmentDetails,
    fetchingWarehouseShipments,
  } = useSelector((state) => state.postShipment || {});

  const { shipments } = shipmentDetails || {};

  return (
    <StepFiveWrapper>
      <Spin tip='Loading...' spinning={fetchingWarehouseShipments}>
        <div className='cards-items-wrapper'>
          {shipments.map(({
            amazon_reference_id,
            amazon_shipment_confirmation_id,
            amazon_shipment_id,
            destination_address_line_1: address_line1,
            destination_city: city,
            destination_country_code: country,
            destination_name: name,
            destination_postal_code: postal_code,
            destination_state_or_province_code: state,
            is_completed,
          }, index) => {
            const formattedAddress = `${name} ${address_line1} ${city}, ${state} ${postal_code} ${country}`;

            return (
              <div className='card-item' key={index}>
                <header>
                  <p>{amazon_shipment_confirmation_id}</p>
                  <Badge status={is_completed ? 'Completed' : 'Pending'} />
                </header>
                <div className='items-content'>
                  <div className='content'>
                    <p>Amazon Reference ID</p>
                    <p>{amazon_reference_id || '---'}</p>
                  </div>
                  <div className='content'>
                    <p>Ship To</p>
                    <p>{formattedAddress}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Spin>
    </StepFiveWrapper>
  )
}

export default StepFive
